/** @jsxImportSource @emotion/react */

import { COLORS } from '@btime/constants'
import { css } from '@emotion/react'
import React from 'react'

import { generateFlexColumnStyle } from './FlexGrid'
import { getMarginInRems } from '../../utils/style/separator'
import breakpoints from '../../utils/constants/breakpoints'

export const PanelContent = ({
  children,
  padding,
  smallPadding,
  mediumPadding,
  smallPaddingTopBottom,
  mediumPaddingTopBottom,
  noPaddingBottom,
  noPaddingTop,
  noPadding,
  ...props
}) => {
  padding = padding || 1.9375

  if (mediumPadding) padding = 1.2
  if (smallPadding) padding = 0.6

  let paddingTopBottom = padding

  if (!!smallPaddingTopBottom) paddingTopBottom = 0.6
  if (!!mediumPaddingTopBottom) paddingTopBottom = 1.2

  const style = css`
    width: 100%;
    height: 100%;
    padding: ${paddingTopBottom}rem ${padding}rem;
    ${noPaddingBottom ? 'padding-bottom: 0;' : ''}
    ${noPaddingTop ? 'padding-top: 0;' : ''}
		${noPadding ? 'padding: 0;' : ''}

		@media (max-width: ${breakpoints.sm}px) {
      ${!noPadding && !noPaddingBottom ? 'padding:  1rem;' : ''}
    }
  `

  return (
    <div className="panelContent" css={style}>
      {children}
    </div>
  )
}

const Panel = props => {
  const {
    bgImage,
    smallPadding,
    mediumPadding,
    smallMargin,
    children,
    wrapOn,
    noMargin,
    noMarginTop,
    noMarginRight,
    noPadding,
    bgColor,
    borderColor,
    noRadius,
    flex,
    width,
    borderLeftColor,
    borderTopColor,
    lineBorder,
    noShadow,
    maxWidth,
    minHeight,
    minWidth,
    height,
    maxHeight,
    opacity,
    center = false,
    ...restProps
  } = props

  const style = css`
    display: flex;
    ${center ? `align-items: center;` : ''}
    flex: 1;
    margin: ${getMarginInRems(smallMargin ? 1 : 3)}rem;
    ${!noRadius && 'border-radius: 5px;'}
    background: ${bgColor || COLORS.white};
    box-shadow: ${!lineBorder && !noShadow && COLORS.lightShadow1};
    background-image: url(${bgImage});
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    ${opacity ? `opacity: ${opacity};` : ''}
    ${(!!lineBorder || borderColor) && `border: solid 1px ${borderColor || COLORS.light3};`}
    ${noMargin && 'margin: 0;'}
		${noMarginTop && 'margin-top: 0;'}
		${noMarginRight && 'margin-right: 0;'}
		${minHeight && `min-height: ${minHeight};`}
		${height && `height: ${height};`}
    ${maxHeight && `max-height: ${maxHeight};`}
		${minWidth && `min-width: ${minWidth};`}
		${!!borderLeftColor && `border-left: 0.4rem solid ${borderLeftColor};`}
		${!!borderTopColor && `border-top: 0.4rem solid ${borderTopColor};`}

		${generateFlexColumnStyle({ flex, width, wrapOn, maxWidth })} /* @media (max-width: ${breakpoints[wrapOn || 'lg']}px) {
			flex-basis: 100%;
		} */
  `

  return (
    <div className="panel" css={style}>
      <PanelContent {...restProps} noPadding={noPadding} smallPadding={smallPadding} mediumPadding={mediumPadding}>
        {children}
      </PanelContent>
    </div>
  )
}

export default Panel
